<template>
  <div :id="`${id}-transliteration`" :class="[hidden ? 'col-12 col-md-6' : 'd-flex flex-wrap w-100']">
    <div v-if="!hidden" :class="classes">
      <TextField
        :rules="transRules"
        :name="`transliterate-${name}`"
        :id="`transliterate-${id}`"
        @blur="transliterate"
        :label="transLabel"
        :value="innerValueToTransliterate"
        :placeholder="placeholder"
        :disabled="disabled"
      />
    </div>
    <div :class="classes">
      <TextField
        :rules="rules"
        :value="innerValue"
        :name="name"
        :id="id"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { FormRegex } from '@/infrastructure/Configuration'
import TextField from './TextField.vue'
import { transliterationService } from '@/infrastructure/Factory'
export default {
  name: 'Transliteration',
  props: {
    classes: {
      type: String
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    transLabel: {
      type: String
    },
    rules: {
      type: Object
    },
    transRules: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    hidden: {
      type: Boolean
    }
  },
  data: () => ({
    FormRegex,
    innerValue: '',
    innerValueToTransliterate: ''
  }),
  components: {
    TextField
  },
  methods: {
    async transliterate(value) {
      if (value === '') {
        this.innerValue = ''
      } else {
        this.innerValue = await this.transliteration(global.UtilsText.parseTextFromString(value))
      }
    },
    async transliteration(value) {
      try {
        return await transliterationService.transliterate(value)
      } catch {
        return ''
      }
    }
  }
}
</script>

<style lang="scss"></style>
